import { connect } from 'react-redux';

import { ErrorPageBoundary, ErrorPageBoundaryProps } from '../../components/ErrorPageBoundary/ErrorPageBoundary';
import { State } from '../../typings/state';
import { TStateProps } from '../../typings/utils';

type OwnProps = Pick<ErrorPageBoundaryProps, 'globalScreenCls'>;

type StateProps = TStateProps<ErrorPageBoundaryProps, OwnProps>;

const mapStateToProps = (state: State): StateProps => {
    return {
        hasGlobalError: state.commonData.screenError.isVisible
    };
};

export const ErrorPageBoundaryContainer = connect<StateProps, {}, OwnProps>(mapStateToProps)(ErrorPageBoundary);
